<template>
  <div class="dashboard-filter-panel" v-bind:style="filterPanelStyle">
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="false"
      background-color="#f0f0f0"
      loader="bars"
      v-bind:height="0"
      v-bind:width="0"
    >
    </loading>
    <Flex v-if="showFilter" column grow wrap class="filter-container">
      <Flex options-header>{{ $t('map.element.title') }}</Flex>
      <MapFilterOption
        :showPinsOnload="getShowPinsOnload"
        v-for="item in options"
        :key="item.id"
        :name="item.name"
        :id="item.id"
        :iconSrc="item.icon"
        @toggleUpdate="optionUpdate"
      ></MapFilterOption>
      <MapComponentFilter
        v-for="item in components"
        :key="item.componentId"
        :component="item.componentId"
        :label="item.componentName"
        @update="optionUpdate"
      ></MapComponentFilter>
      <Flex v-if="showPoiTypes" poiTypes-header>{{ $t('poi.sidebar.label') }}</Flex>
      <PoiTypeOption
        v-for="item in poiTypes"
        :key="item.id"
        :name="item.name"
        :id="item.id"
        :iconSrc="item.icon"
        @toggleUpdate="optionUpdate"
      ></PoiTypeOption>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Loading from 'vue-loading-overlay'
import MapFilterOption from './MapFilterOption'
import MapComponentFilter from './MapComponentFilter'
import PoiTypeOption from './PoiTypeOption'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  /**
   * Name of the component
   */
  name: 'MapFilter',

  /**
   * Components
   */
  components: {
    Flex,
    MapFilterOption,
    MapComponentFilter,
    PoiTypeOption,
    Loading,
  },

  /**
   * This components properties
   */
  props: {
    options: [Array],
    showPinsOnload: Boolean,
    components: [Array],
    availableHeight: Number,
    loading: Boolean,
    poiTypes: [Array],
  },
  /**
   * This components data attributes
   */
  data() {
    return {
      showFilter: true,
    }
  },
  /**
   * Computed methods
   */
  computed: {
    getShowPinsOnload() {
      return this.showPinsOnload
    },
    filterPanelStyle() {
      return {
        minHeight: `${this.availableHeight - this.bottomMargin()}px`,
        marginBottom: `${this.bottomMargin()}px`,
      }
    },
    showPoiTypes() {
      return this.poiTypes.length > 0
    },
  },
  /**
   * Component methods
   */
  methods: {
    /**
     * Emits a map filter event
     */
    optionUpdate(event) {
      this.$emit('mapFilterEvent', event)
    },
    bottomMargin() {
      return this.components.length > 0 ? 280 : 0
    },
  },
}
</script>

<style lang="postcss" scoped>
.dashboard-filter-panel {
  @apply absolute top-0 left-0 z-10 ml-1 pt-4 w-11/12 overflow-hidden;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.filter-container {
  @apply bg-gray-100 ml-2 mb-5;
}
.options-header {
  @apply p-2 bg-gray-300 mb-1 font-bold whitespace-no-wrap;
}
.poiTypes-header {
  @apply p-2 mt-4 bg-gray-300 mb-1 font-bold whitespace-no-wrap;
}
</style>
